import { render } from "./ChatDashboard.vue?vue&type=template&id=217268b9&ts=true"
import script from "./ChatDashboard.vue?vue&type=script&lang=ts"
export * from "./ChatDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__